import { Action } from 'redux';
import _ from 'underscore';
import { UserNotificationState } from '../../app/state/UserNotificationState';
import { isGetUserNotificationsSucceededAction, isGetUserNotificationsFailedAction } from './actions/GetUserNotificationsAction';
import { isUpdateUserNotificationsStatusSucceedAction } from './actions/UpdateUserNotificationStatusAction';
import { isDeleteUserNotificationSucceedAction } from './actions/DeleteUserNotification';
import { NotificationDisplayMode } from '../components/NotificationPanel';
import { isCheckHasUnseenUserNotificationsSucceededAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { isUpdateLastSeenUserNotificationSucceededAction } from './actions/UpdateLastSeenUserNotificationAction';


const initialState: UserNotificationState = {
  hasUnseenNotifications: false,
  notifications: null,
  notificationDisplayMode: NotificationDisplayMode.NotificationLoading
};

export function userNotificationsReducer(
  prevState: UserNotificationState = initialState,
  action: Action = null
): UserNotificationState {
  if (isGetUserNotificationsSucceededAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: action.notifications,
      notificationDisplayMode: NotificationDisplayMode.NotificationLoaded
    };
  } else if (isUpdateUserNotificationsStatusSucceedAction(action)) {
    const { notifications} = prevState;
    _.forEach(action.notificationIds, (id: string) => {
      notifications[id].read = action.isRead;
    });
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: _.clone(notifications),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isDeleteUserNotificationSucceedAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: _.omit(prevState.notifications, action.notificationId),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isCheckHasUnseenUserNotificationsSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: action.hasUnseenUserNotifications,
    };
  } else if (isUpdateLastSeenUserNotificationSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: false
    };
  } else if (isGetUserNotificationsFailedAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: prevState.notifications,
      notificationDisplayMode: NotificationDisplayMode.NotificationLoadFailed
    };
  } else {
    return prevState;
  }
}
